import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import WordPressIcon from '@/components/icons/WordPressIcon.vue';

Vue.use(Vuetify);

export default new Vuetify({
  theme: {
    themes: {
      light: {
        primary: '#dbb77a',
        secondary: '#c29445',
        accent: '#857251',
        error: '#ff0000',
      },
    },
  },
  icons: {
    values: {
      wordpress: { // name of custom icon
        component: WordPressIcon, // custom icon component
      },
    },
  },
});
